/**
 * @fileoverview Legal-page chrome Spanish (ES) bundle — the same key set as `en.js`, leaf for leaf.
 * @package @puffin-core/legal-content
 *
 * Machine-authored (PACKAGE-I18N-SEAT U3, 2026-10-23) and recorded as `'machine'` in `_meta.js`, so every
 * leaf is in the native-speaker review queue rather than passing as reviewed copy. Register: *usted*.
 *
 * `chromeLanguage` is `'es'` BY NATURE: it is the tag of the language this bundle is written in.
 *
 * @module @puffin-core/legal-content/strings/es
 */

export const LEGAL_CONTENT_ES = Object.freeze({
  // The language these words are written in — the `lang` of every element worded from this bundle
  chromeLanguage: 'es',

  // The unavailable notice (`components/LegalDocumentPage.jsx`)
  unavailableTitle: 'Documento no disponible',
  unavailableMessage:
    'Este documento no está disponible en este momento. Comuníquese con nosotros y se lo proporcionaremos.',

  // The document's chrome (`components/LegalDocumentPage.jsx`)
  tableOfContents: 'Índice',
  effectiveDate: 'Fecha de entrada en vigor: {{date}}',
  contactInformation: 'Información de contacto',
  contactEmail: 'Correo electrónico:',

  // A subprocessor's row labels (`components/SubprocessorList.jsx`)
  subprocessorRole: 'Función',
  subprocessorDataCategories: 'Categorías de datos',
  subprocessorLocation: 'Ubicación',
  subprocessorLegalEntity: 'Entidad legal',
  subprocessorReferences: 'Referencias',
});

export default LEGAL_CONTENT_ES;
